/*
  Keeps Aris Product Options add-on lines ("Do you want to stitch") in step with
  the saree that added them.

  The app ships its own sync, but it only hooks the Dawn cart page. This theme's
  cart drawer re-renders through CartItems.updateQuantity, which the app never
  sees, so a quantity change in the drawer left the add-on stale and removing the
  saree left the add-on orphaned in the cart on its own.

  Parent line carries  _apo_order: <order>
  Add-on line carries  _apo_order: "Added by: <order> * <per>"
  where <per> is the add-on quantity per unit of the parent.
*/
(function () {
  if (window.__mtlApoQtySync) return;
  window.__mtlApoQtySync = true;

  var ADDED_BY = /^Added by:\s*(\d+)\s*\*\s*(\d+)/;
  var SOURCE = 'mtl-apo-qty-sync';
  var running = false;
  var timer = null;

  function orderOfParent(item) {
    var raw = item.properties && item.properties._apo_order;
    if (raw === undefined || raw === null || raw === '') return null;
    raw = String(raw);
    return ADDED_BY.test(raw) ? null : raw;
  }

  function orderOfAddon(item) {
    var raw = item.properties && item.properties._apo_order;
    if (typeof raw !== 'string') return null;
    var match = raw.match(ADDED_BY);
    if (!match) return null;
    return { order: match[1], per: parseInt(match[2], 10) || 1 };
  }

  // Returns { key: wantedQuantity } for every add-on that is out of step, or null.
  function plan(cart) {
    if (!cart || !cart.items) return null;
    var parents = {};
    cart.items.forEach(function (item) {
      var order = orderOfParent(item);
      if (order) parents[order] = (parents[order] || 0) + item.quantity;
    });
    var updates = null;
    cart.items.forEach(function (item) {
      var addon = orderOfAddon(item);
      if (!addon) return;
      var wanted = (parents[addon.order] || 0) * addon.per;
      if (wanted === item.quantity) return;
      updates = updates || {};
      updates[item.key] = wanted;
    });
    return updates;
  }

  function sectionsToRender() {
    var drawerItems = document.querySelector('cart-drawer-items');
    var cartItems = document.querySelector('cart-items');
    var host = drawerItems || cartItems;
    if (host && typeof host.getSectionsToRender === 'function') {
      try {
        return { host: host, sections: host.getSectionsToRender() };
      } catch (error) {
        return null;
      }
    }
    return null;
  }

  function render(host, sections, parsed) {
    if (!parsed.sections) return;
    sections.forEach(function (section) {
      var container = document.getElementById(section.id);
      if (!container) return;
      // Same fallback as CartItems.updateQuantity: the section element itself
      // when the inner selector is not present (the cart icon bubble).
      var target = (section.selector && container.querySelector(section.selector)) || container;
      var html = parsed.sections[section.section];
      if (!target || !html) return;
      try {
        target.innerHTML = host.getSectionInnerHTML(html, section.selector);
      } catch (error) {
        /* A section we cannot parse is left as-is rather than blanked. */
      }
    });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', parsed.item_count === 0);
    var footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.toggle('is-empty', parsed.item_count === 0);
    var items = document.querySelector('cart-items');
    if (items) items.classList.toggle('is-empty', parsed.item_count === 0);
  }

  function reconcile() {
    if (running) return;
    running = true;
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var updates = plan(cart);
        if (!updates) return null;
        var target = sectionsToRender();
        var body = { updates: updates };
        if (target) {
          body.sections = target.sections.map(function (section) { return section.section; });
          body.sections_url = window.location.pathname;
        }
        return fetch(window.routes.cart_update_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (response) { return response.json(); })
          .then(function (parsed) {
            if (target) render(target.host, target.sections, parsed);
            return parsed;
          });
      })
      .then(function (parsed) {
        running = false;
        if (parsed) publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: parsed });
      })
      .catch(function () {
        // Leave the cart as the server has it; the next cart event retries.
        running = false;
      });
  }

  function schedule(event) {
    if (event && event.source === SOURCE) return;
    clearTimeout(timer);
    // Let the app's own cart-page sync land first, so this only fixes what it missed.
    timer = setTimeout(reconcile, 450);
  }

  function start() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(start, 300);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }

  start();
})();
